import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { ApolloProvider } from "@apollo/client/react";
import client from "./graphql/client.js";
import { Web3Provider } from "./providers/Web3Provider.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { LocaleProvider } from "./lib/i18n.jsx";

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={clientId}>
    <ApolloProvider client={client}>
      <LocaleProvider>
        <Web3Provider>
          <App />
        </Web3Provider>
      </LocaleProvider>
    </ApolloProvider>
  </GoogleOAuthProvider>
);
